document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('.product-carousel__track');
    var prevBtn = carousel.querySelector('.product-carousel__arrow--prev');
    var nextBtn = carousel.querySelector('.product-carousel__arrow--next');

    if (!track) return;

    function scrollByCard(direction) {
      var card = track.querySelector('.product-carousel__card');
      var cardWidth = card ? card.getBoundingClientRect().width + 24 : 300;
      track.scrollBy({ left: direction * cardWidth * 2, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
  });
});
